// extracted by mini-css-extract-plugin
export default {"noDataIcon":"noData_noDataIcon__kkOBY","title":"noData_title__gTccu"};